import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import chroma from 'chroma-js';

@Component({
  selector: 'bepatient-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
  standalone: false
})
export class AvatarComponent implements OnChanges {
  public initial: string;
  public style: { background: string; color: string };

  @Input() name: string;
  @Input() color: string;
  @Input() icon: string;

  ngOnChanges({ color, name }: SimpleChanges) {
    if (color && color.currentValue) {
      this.style = this.getStyle(color.currentValue);
    }
    if (name && name.currentValue) {
      this.initial = this.getInitial(name.currentValue);
    }
  }

  private getInitial(currentValue: string): string {
    return currentValue.charAt(0);
  }

  private getStyle(color: string): { background: string; color: string } {
    return {
      background: color,
      color: chroma(color).luminance() < 0.6 ? '#fafafa' : '#2e2e2e'
    };
  }
}
